import React, { Component } from 'react'
import { TimePicker } from 'antd'
import FormItem from './FormItem'
import moment from 'moment'
import { getAttribute } from '../utils/models'

class Time extends Component {

    render() {
        const { getFieldDecorator } = this.props.form
        const attribute = getAttribute(this.props.model, this.props.attribute)

        let { fieldSettings } = this.props

        fieldSettings.initialValue = this.props.value ? moment(this.props.value, 'HH:mm:ss') : undefined

        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, fieldSettings)(
                    <TimePicker
                        size='large'
                        disabled={this.props.disabled}
                        allowEmpty={!attribute.required}
                        style={{ width: '100%' }}
                        onChange={this.props.handleChange}
                        format={'H:mm'}
                        placeholder={''}
                    />
                )}
            </FormItem>
        )
    }

}

export default Time


// WEBPACK FOOTER //
// ./src/inputs/Time.js